import { useConfig } from '@/utils/runtimeConfig';

/**
 * Returns the public contact details for the app (phone, email, WhatsApp link).
 *
 * Source of truth: the Command Center `system_configs` collection, surfaced
 * through `GET /api/config` → `contact` → cached in window.ZEN_CONFIG via
 * runtimeConfig.loadRuntimeConfig().
 *
 * Non-technical admins can update these values in Command Center → System Config
 * (keys: `support_phone`, `support_email`, `whatsapp_number`) without a redeploy.
 */
const DEFAULTS = {
  support_phone: '+91 87904 60259',
  support_email: 'info@zenstudios.in',
  whatsapp_number: '918790460259',
  support_phone_tel: '+918790460259',
  whatsapp_url: 'https://wa.me/918790460259',
};

export function useAppConfig() {
  const cfg = useConfig();
  const contact = cfg?.contact || {};
  return { ...DEFAULTS, ...contact };
}

export default useAppConfig;
